import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "flowbite"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["trigger", "menu"]
  static values = {
    placement: { type: String, default: "left-end" },
    offset: { type: Number, default: 10 }
  }

  connect() {
    this.dropdown = new Dropdown(this.menuTarget, this.triggerTarget, {
      placement: this.placementValue,
      offsetDistance: this.offsetValue,
      onHide: () => {}
    })
  }

  disconnect() {
    // Clean up Flowbite dropdown instance
    if (this.dropdown) {
      this.dropdown.destroy()
    }
  }

  // Hide dropdown programmatically
  hide() {

    // To fix the "blocked aria-hidden warning", we need to check if the focus is currently inside the dropdown menu before hiding it. If it is, we move the focus back to the dropdown trigger button (the ellipsis icon) before hiding the menu.
    if (this.menuTarget.contains(document.activeElement)) {
      this.triggerTarget.focus()
    }
    this.dropdown.hide()
  }

  // Show dropdown programmatically
  show() {
    this.dropdown.show()
  }

  // Toggle dropdown programmatically
  toggle() {
    this.dropdown.toggle()
  }
}